// import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Tooltip, Button, Spinner, Badge } from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/revisikeuanganService";

import DataTableBloc from "../Blocs/DataTableBloc";
import IndexBloc from "../Blocs/IndexBloc";
import apiResponse from "../../../../../services/apiResponse";
import { Link } from "react-router-dom";
import moment from "moment";
import Shimmer from "react-shimmer-effect";
const formatDateWithTime = (value) => {
  if (value != "-") {
    let date = new Date(value);
    const day = date.toLocaleString("id-ID", { day: "2-digit" });
    const month = date.toLocaleString("id-ID", { month: "short" });
    const year = date.toLocaleString("id-ID", { year: "numeric" });
    const time = date.toLocaleTimeString("id-ID");

    return (
      day +
      " " +
      month +
      " " +
      year +
      " " +
      time.substring(0, 5).replace(/\./g, ":")
    );
  } else {
    return value;
  }
};

class TableActiveComponent extends Component {
  dataTableBloc = new DataTableBloc();
  indexBloc = new IndexBloc();
  queryParams = new URLSearchParams(window.location.search);

  historyTable = "EmployeeRapelTunsusTableActive";
  defaultOrder = "special_allowance_summary_rev_employee_full_name";
  defaultSize = 10;
  defaultSort = "asc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };
  modal_confirm_status = 0;
  modal_confirm_message = "";
  modal_confirm_sucess_message = "data berhasil diproses";
  modal_confirm_error_message = "data gagal diproses";

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      updateUuid: null,
      updateNip: null,
      inactiveUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
      dataSelected: [],
      checkAll: false,
      revision_uuid: null,
    };
  }
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      uuid: this.queryParams.get("period_uuid"),
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
      is_process: 0,
    };
    // await this.dataTableBloc.fetchRowTable(query, this.source.token);
    await this.dataTableBloc.fetchRapelTable(query, this.source.token);
  };

  handleChecked = (e, uuid) => {
    var checked = e.target.checked;
    if (checked) {
      this.setState({
        dataSelected: [...this.state.dataSelected, uuid],
      });
    } else {
      var filteredAry = this.state.dataSelected.filter((e) => e !== uuid);
      this.setState({
        dataSelected: filteredAry,
      });
    }
    console.log(uuid, checked);
  };

  handleCheckAll = (e) => {
    let checked = e.target.checked;
    let uuidSelected = [];
    for (let i = 0; i < this.state.rows.length; i++) {
      let thisId = this.state.rows[i].promotion_id;
      let thisUuid = this.state.rows[i].promotion_uuid;
      this.setState({
        [`check${thisId}`]: !this.state.checkAll,
      });
      if (checked == true) {
        uuidSelected[i] = thisUuid;
      }
    }

    this.setState({
      checkAll: !this.state.checkAll,
      dataSelected: uuidSelected,
    });
  };

  handleButtonProcess = () => {
    console.log(this.state.dataSelected);
    this.modal_confirm_message =
      "Apakah anda yakin akan menambahkan pegawai terpilih?";
    this.modal_confirm_status = 1;
    this.setState({
      confirm: true,
    });
  };

  resetTable = () => {
    this.setState({
      dataSelected: [],
    });
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        let data_status = parseInt(this.modal_confirm_status);
        if (data_status === 1) {
          let formData = {
            uuids: this.state.dataSelected,
          };
        } else {
          this.activeData();
        }
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  inactiveData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };

  exportExcel = () => {
    let additionalFilter = this.props.additionalFilter;
    this.dataTableBloc.fetchRevisiExport({
      uuid: this.queryParams.get("period_uuid"),
    });

    console.log(additionalFilter);
  };

  loadDetail = () => {
    this.dataTableBloc.fetchDetailBobot({
      uuid: this.queryParams.get("period_uuid"),
      // year: this.props.year,
      // month: this.props.month,
    });
  };

  componentDidMount() {
    this.setTokenAPI();

    this.dataTableBloc.rapeltableChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;

          // // set state for every checkbox
          // for (let i = 0; i < response.result.length; i++) {
          //   let thisId = response.result[i].promotion_id;
          //   this.setState({
          //     [`check${thisId}`]: false,
          //   });
          // }
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });

          this.loadDetail();

          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.revisiExportChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          window.open(link.file_url, "_blank");
          this.setState({
            loading: false,
            success: true,
          });
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1000);
          break;
        case apiResponse.ERROR:
          this.setState({
            urlFileDetail: link,
            loading: false,
            failed: true,
          });
          setTimeout(function () {
            this.setState({
              failed: false,
            });
          }, 1000);
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.detailBobotChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingDetail: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingDetail: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            presensi: response.presensi,
            skp: response.skp,
            penilaian: response.penilaian,
            loadingDetail: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.dataTableBloc.rowtableChannel.unsubscribe();
  }

  columns = [
    {
      key: "special_allowance_summary_rev_employee_nip",
      text: "Pegawai",
      className: "",
      sortable: true,
      cell: (record) => {
        return (
          <div
            dangerouslySetInnerHTML={{
              __html:
                "<b>" +
                record.special_allowance_summary_rev_employee_nip +
                "</b><br>" +
                record.special_allowance_summary_rev_employee_full_name +
                "<br>" +
                record.special_allowance_summary_rev_employee_full_name,
            }}
          />
        );
      },
    },
    {
      key: "special_allowance_summary_rev_type_name",
      text: "Jenis Koreksi",
      className: "",
      sortable: true,
      cell: (record) => {
        return (
          <div
            dangerouslySetInnerHTML={{
              __html: record.special_allowance_summary_rev_type_name,
            }}
          />
        );
      },
    },

    {
      key: "special_allowance_summary_rev_status",
      text: "Status",
      sortable: false,
      cell: (record) => {
        let status = parseInt(record.special_allowance_summary_rev_status);
        if (status == -1) {
          status = (
            <label className="badge rounded-pill bg-soft-info font-size-12">
              {record.special_allowance_summary_rev_status_name}
            </label>
          );
        } else if (status == 0) {
          status = (
            <label className="badge rounded-pill bg-soft-success font-size-12">
              {record.special_allowance_summary_rev_status_name}
            </label>
          );
        } else if (status == 1) {
          status = (
            <label className="badge rounded-pill bg-soft-success font-size-12">
              {record.special_allowance_summary_rev_status_name}
            </label>
          );
        } else if (status == 2) {
          status = (
            <label className="badge rounded-pill bg-soft-error font-size-12">
              {record.special_allowance_summary_rev_status_name}
            </label>
          );
        }
        return <span> {status} </span>;
      },
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 120,
      sortable: false,
      align: "center",
      cell: (record) => {
        const thisId = record.special_allowance_summary_rev_id;
        return (
          <Fragment>
            {record.special_allowance_summary_rev_status == 0 ? (
              <span>
                <button
                  className="btn btn-primary btn-sm"
                  id={"update-" + thisId}
                  onClick={() => {
                    this.setState({
                      updateUuid:
                        record.special_allowance_summary_rev_employee_uuid,
                      updateNip:
                        record.special_allowance_summary_rev_employee_nip,
                      revision_uuid: record.special_allowance_summary_rev_uuid,
                    });
                  }}
                  style={{
                    marginRight: "2px",
                    padding: "2px 5px",
                  }}
                >
                  {this.props.periode_status == 0 ? (
                    <>
                      <i className="uil-check-square"></i>
                    </>
                  ) : (
                    <>
                      <i className="uil-file-alt"></i>
                    </>
                  )}
                </button>
                <Tooltip
                  style={{
                    marginBottom: 2,
                  }}
                  placement="top"
                  isOpen={this.state["update" + thisId]}
                  target={"update-" + thisId}
                  toggle={() => {
                    this.setState({
                      ["update" + thisId]: !this.state["update" + thisId],
                    });
                  }}
                >
                  {this.props.periode_status == 0
                    ? "Buat Revisi"
                    : "Lihat Revisi"}
                </Tooltip>
              </span>
            ) : null}
            {record.special_allowance_summary_rev_status == 1 ? (
              <span>
                <Link
                  to={
                    `?detail&uuid=` +
                    this.queryParams.get("period_uuid") +
                    `&employee_uuid=` +
                    record.special_allowance_summary_rev_employee_uuid
                  }
                >
                  <button
                    className="btn btn-success btn-sm"
                    id={"detail-" + thisId}
                    style={{
                      marginRight: "2px",
                      padding: "2px 5px",
                    }}
                  >
                    <i className="uil-file-search-alt"></i>
                  </button>
                  <Tooltip
                    style={{
                      marginBottom: 2,
                    }}
                    placement="top"
                    isOpen={this.state["detail" + thisId]}
                    target={"detail-" + thisId}
                    toggle={() => {
                      this.setState({
                        ["detail" + thisId]: !this.state["detail" + thisId],
                      });
                    }}
                  >
                    Detail
                  </Tooltip>
                </Link>
              </span>
            ) : null}
          </Fragment>
        );
      },
    },
  ];

  render() {
    let shimmer = (
      <Shimmer>
        <div
          style={{
            width: "3ch",
            height: "1rem",
            verticalAlign: "middle",
          }}
        ></div>
      </Shimmer>
    );
    return (
      <>
        <div className="d-flex mb-3"></div>

        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <thead className="table-primary">
              <tr style={{ border: "1px solid #c8cce1" }}>
                <th className="text-center align-middle" width="*" rowSpan="2">
                  No
                </th>
                <th className="text-center align-middle" width="*" rowSpan="2">
                  Pegawai
                </th>
                <th
                  className="text-center align-middle table-warning"
                  style={{ backgroundColor: "rgb(255, 250, 233)" }}
                  width="*"
                  colSpan="5"
                >
                  Sebelum
                </th>
                <th
                  className="text-center align-middle table-success"
                  style={{ backgroundColor: "#e6ffe5" }}
                  width="*"
                  colSpan="6"
                >
                  Sesudah
                </th>
              </tr>
              <tr style={{ border: "1px solid #c8cce1" }}>
                <th
                  className="text-center align-middle table-warning"
                  style={{ backgroundColor: "rgb(255, 250, 233)" }}
                  width="*"
                >
                  Grade
                </th>
                <th
                  className="text-center align-middle table-warning"
                  style={{ backgroundColor: "rgb(255, 250, 233)" }}
                  width="*"
                >
                  {" "}
                  Presensi
                  <br />
                  (Bobot{" "}
                  {this.state.loadingTable === false &&
                  this.state.loadingDetail === false
                    ? this.state.presensi
                    : shimmer}
                  %)
                </th>
                <th
                  className="text-center align-middle table-warning"
                  style={{ backgroundColor: "rgb(255, 250, 233)" }}
                  width="*"
                >
                  SKP
                  <br />
                  (Bobot{" "}
                  {this.state.loadingTable === false &&
                  this.state.loadingDetail === false
                    ? this.state.skp
                    : shimmer}
                  %)
                </th>
                <th
                  className="text-center align-middle table-warning"
                  style={{ backgroundColor: "rgb(255, 250, 233)" }}
                  width="*"
                >
                  Penilaian Pimpinan
                  <br />
                  (Bobot{" "}
                  {this.state.loadingTable === false &&
                  this.state.loadingDetail === false
                    ? this.state.penilaian
                    : shimmer}
                  %)
                </th>
                <th
                  className="text-center align-middle table-warning"
                  style={{ backgroundColor: "rgb(255, 250, 233)" }}
                  width="*"
                >
                  Total
                </th>
                <th
                  className="text-center align-middle table-warning"
                  style={{ backgroundColor: "#e6ffe5" }}
                  width="*"
                >
                  Grade
                </th>
                <th
                  className="text-center align-middle table-warning"
                  style={{ backgroundColor: "#e6ffe5" }}
                  width="*"
                >
                  Presensi
                  <br />
                  (Bobot{" "}
                  {this.state.loadingTable === false &&
                  this.state.loadingDetail === false
                    ? this.state.presensi
                    : shimmer}
                  %)
                </th>
                <th
                  className="text-center align-middle table-warning"
                  style={{ backgroundColor: "#e6ffe5" }}
                  width="*"
                >
                  SKP
                  <br />
                  (Bobot{" "}
                  {this.state.loadingTable === false &&
                  this.state.loadingDetail === false
                    ? this.state.skp
                    : shimmer}
                  %)
                </th>
                <th
                  className="text-center align-middle table-warning"
                  style={{ backgroundColor: "#e6ffe5" }}
                  width="*"
                >
                  Penilaian Pimpinan
                  <br />
                  (Bobot{" "}
                  {this.state.loadingTable === false &&
                  this.state.loadingDetail === false
                    ? this.state.penilaian
                    : shimmer}
                  %)
                </th>
                <th
                  className="text-center align-middle table-warning"
                  style={{ backgroundColor: "#e6ffe5" }}
                  width="*"
                >
                  Total
                </th>
                <th
                  className="text-center align-middle table-warning"
                  style={{ backgroundColor: "#e6ffe5" }}
                  width="*"
                >
                  Aksi
                </th>
              </tr>
            </thead>
            <tbody>
              {this.state.loadingTable == false ? (
                this.state.rows.length > 0 ? (
                  this.state.rows.map((data, index) => {
                    return (
                      <tr
                        id={"tr_tunkin_" + index}
                        style={{ border: "1px solid #c8cce1" }}
                      >
                        {/* 
													<td>
                          <b>{data.presensi_summary_employee_nip}</b> <br /> {data.employee_full_name} <br />
                          <Button outline
                          color="primary"
                          className="btn-sm"
                          disabled={this.props.additionalFilter.verification_data_is_verif_tunkin == 1 ? true : false}
                          onClick={() => this.setState({
                            confirm: true,
                            runType: 2,
                            employee_nip: data.presensi_summary_employee_nip,
                            confirmInfo: "Apakah anda yakin akan melakukan kalkulasi ulang untuk data " + data.employee_full_name + " ?"
                          })}
                          >
                          <i className="uil-refresh"></i> Kalkulasi Ulang
														</Button>
													</td> */}

                        <td className="text-center">{(index += 1)}</td>
                        <td>
                          <b>
                            {data.special_allowance_summary_rev_employee_nip}
                          </b>
                          <br />
                          {
                            data.special_allowance_summary_rev_employee_full_name
                          }
                          <br />
                          {data.current_position_name_new}
                        </td>
                        <td
                          className="text-center table-warning"
                          style={{ backgroundColor: "rgb(255, 250, 233)" }}
                        >
                          {data.special_allowance_summary_emp_grade_tunsus}
                        </td>
                        <td
                          className="text-center table-warning"
                          style={{ backgroundColor: "rgb(255, 250, 233)" }}
                        >
                          {data.special_allowance_summary_presensi}
                        </td>
                        <td
                          className="text-center table-warning"
                          style={{ backgroundColor: "rgb(255, 250, 233)" }}
                        >
                          {data.special_allowance_summary_skp}
                        </td>
                        <td
                          className="text-center table-warning"
                          style={{ backgroundColor: "rgb(255, 250, 233)" }}
                        >
                          {data.special_allowance_summary_penilaian_pimpinan}
                        </td>
                        <td
                          className="text-center table-warning"
                          style={{ backgroundColor: "rgb(255, 250, 233)" }}
                        >
                          {data.special_allowance_summary_total}
                        </td>

                        <td
                          className="text-center table-success"
                          style={{ backgroundColor: "#e6ffe5" }}
                        >
                          {data.special_allowance_summary_rev_emp_grade_tunsus}
                        </td>
                        <td
                          className="text-center table-success"
                          style={{ backgroundColor: "#e6ffe5" }}
                        >
                          {data.special_allowance_summary_rev_presensi}
                        </td>
                        <td
                          className="text-center table-success"
                          style={{ backgroundColor: "#e6ffe5" }}
                        >
                          {data.special_allowance_summary_rev_skp}
                        </td>
                        <td
                          className="text-center table-success"
                          style={{ backgroundColor: "#e6ffe5" }}
                        >
                          {
                            data.special_allowance_summary_rev_penilaian_pimpinan
                          }
                        </td>
                        <td
                          className="text-center table-success"
                          style={{ backgroundColor: "#e6ffe5" }}
                        >
                          {data.special_allowance_summary_rev_total}
                        </td>

                        {/* <td className="text-center table-success"  style={{ backgroundColor:'#e6ffe5' }} >{data.presensi_summary_emp_grade_akhir}</td>
													<td className="text-center table-success"  style={{ backgroundColor:'#e6ffe5' }} >{data.presensi_summary_tunkin_plt_plh}</td>
													<td className="text-center table-success"  style={{ backgroundColor:'#e6ffe5' }} >{data.presensi_summary_presentase_tunkin_tidak_masuk}</td>
													<td className="text-center table-success"  style={{ backgroundColor:'#e6ffe5' }} >{data.presensi_summary_presentase_tunkin_telat_masuk}</td>
													<td className="text-center table-success"  style={{ backgroundColor:'#e6ffe5' }} >{data.presensi_summary_presentase_tunkin_pulang_cepat}</td>
													<td className="text-center table-success"  style={{ backgroundColor:'#e6ffe5' }} >{data.presensi_summary_presentase_tunkin_single_finger}</td>
													<td className="text-center table-success"  style={{ backgroundColor:'#e6ffe5' }} >{data.presensi_summary_presentase_punishment_discipline}</td>
													<td className="text-center table-success"  style={{ backgroundColor:'#e6ffe5' }} >{data.presensi_summary_tunkin_total}</td>
													<td className="text-center table-success"  style={{ backgroundColor:'#e6ffe5' }} >{data.presensi_summary_status_penugasan}</td> */}
                        <td
                          className="text-center table-success"
                          style={{ backgroundColor: "#e6ffe5" }}
                        >
                          <Fragment>
                            {data.special_allowance_summary_rev_status == 0 ? (
                              <span>
                                <button
                                  className="btn btn-primary btn-sm"
                                  id={
                                    "update-" +
                                    data.special_allowance_summary_rev_id
                                  }
                                  onClick={() => {
                                    this.setState({
                                      updateUuid:
                                        data.special_allowance_summary_rev_employee_uuid,
                                      updateNip:
                                        data.special_allowance_summary_rev_employee_nip,
                                      revision_uuid:
                                        data.special_allowance_summary_rev_uuid,
                                    });
                                  }}
                                  style={{
                                    marginRight: "2px",
                                    padding: "2px 5px",
                                  }}
                                >
                                  {this.props.periode_status == 0 ? (
                                    <>
                                      <i className="uil-check-square"></i>
                                    </>
                                  ) : (
                                    <>
                                      <i className="uil-file-alt"></i>
                                    </>
                                  )}
                                </button>
                                <Tooltip
                                  style={{
                                    marginBottom: 2,
                                  }}
                                  placement="top"
                                  isOpen={
                                    this.state[
                                      "update" +
                                        data.special_allowance_summary_rev_id
                                    ]
                                  }
                                  target={
                                    "update-" +
                                    data.special_allowance_summary_rev_id
                                  }
                                  toggle={() => {
                                    this.setState({
                                      ["update" +
                                      data.special_allowance_summary_rev_id]:
                                        !this.state[
                                          "update" +
                                            data.special_allowance_summary_rev_id
                                        ],
                                    });
                                  }}
                                >
                                  {this.props.periode_status == 0
                                    ? "Buat Revisi"
                                    : "Lihat Revisi"}
                                </Tooltip>
                              </span>
                            ) : null}
                            {data.special_allowance_summary_rev_status == 1 ? (
                              <span>
                                <Link
                                  to={
                                    `?detail&uuid=` +
                                    this.queryParams.get("period_uuid") +
                                    `&employee_uuid=` +
                                    data.special_allowance_summary_rev_employee_uuid
                                  }
                                >
                                  <button
                                    className="btn btn-success btn-sm"
                                    id={
                                      "detail-" +
                                      data.special_allowance_summary_rev_id
                                    }
                                    style={{
                                      marginRight: "2px",
                                      padding: "2px 5px",
                                    }}
                                  >
                                    <i className="uil-file-search-alt"></i>
                                  </button>
                                  <Tooltip
                                    style={{
                                      marginBottom: 2,
                                    }}
                                    placement="top"
                                    isOpen={
                                      this.state[
                                        "detail" +
                                          data.special_allowance_summary_rev_id
                                      ]
                                    }
                                    target={
                                      "detail-" +
                                      data.special_allowance_summary_rev_id
                                    }
                                    toggle={() => {
                                      this.setState({
                                        ["detail" +
                                        data.special_allowance_summary_rev_id]:
                                          !this.state[
                                            "detail" +
                                              data.special_allowance_summary_rev_id
                                          ],
                                      });
                                    }}
                                  >
                                    Detail
                                  </Tooltip>
                                </Link>
                              </span>
                            ) : null}
                          </Fragment>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr style={{ border: "1px solid #c8cce1" }}>
                    <td colSpan="17" className="text-center">
                      Tidak Ada Data
                    </td>
                  </tr>
                )
              ) : (
                <tr style={{ border: "1px solid #c8cce1" }}>
                  <td colSpan="17" className="text-center">
                    <Spinner className="m-2" color="primary" />
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          <ConfirmAlert
            confirmTitle="Konfirmasi!"
            confirmInfo={this.modal_confirm_message}
            loadingTitle="Mengirim data..."
            loadingInfo="Tunggu beberapa saat"
            successTitle="Berhasil!"
            successInfo={this.modal_confirm_sucess_message}
            failedTitle="Gagal!"
            failedInfo={this.modal_confirm_error_message}
            showConfirm={this.state.confirm}
            showLoading={this.state.loading}
            showSuccess={this.state.success}
            showFailed={this.state.failed}
            response={this.confirmResponse}
          />
          {this.state.detailUuid !== null ? (
            <Redirect
              to={`/kepegawaian/revisi_tunjangan_khusus.html?pegawai&verifikasi&period_uuid=${this.queryParams.get(
                "period_uuid"
              )}&period_promotion_uuid=${this.state.detailUuid}`}
            />
          ) : null}

          {this.state.updateUuid !== null ? (
            <Redirect
              to={`/kepegawaian/revisi_tunjangan_khusus.html?create_revision&period_uuid=${this.queryParams.get(
                "period_uuid"
              )}&revision_uuid=${this.state.revision_uuid}&employee_uuid=${
                this.state.updateUuid
              }&pegawai_nip=${this.state.updateNip}`}
            />
          ) : null}
        </div>
      </>
    );
  }
}

export default TableActiveComponent;
